import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, IconButton, Typography } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import Flag from "react-world-flags";
import PropTypes from "prop-types";

const LanguageSwitcher = ({
  iconStyle,
  iconClassName,
  labelColor = "white",
  ...props
}) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang) => {
    if (lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem("i18nextLng", lang);
    }
    setAnchorEl(null);
  };

  const getLanguageLabel = (lang) => {
    switch (lang) {
      case "fr":
        return "Fran\u00e7ais";
      case "en":
        return "English";
      case "ar":
        return "\u0639\u0631\u0628\u064a";
      case "es":
        return "Espa\u00f1ol";
      default:
        return "Fran\u00e7ais";
    }
  };

  return (
    <>
      {/* Language icon to open menu */}
      <IconButton
        onClick={handleClick}
        className="language-switcher-icon"
        {...props}
      >
        <LanguageIcon style={iconStyle} className={iconClassName} />
        <Typography
          variant="body2"
          style={{ marginLeft: 8, color: labelColor }}
        >
          {getLanguageLabel(currentLanguage)}
        </Typography>
      </IconButton>

      {/* Language dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        marginThreshold={0}
        sx={{ mt: 0.3, ml: -2 }}
        disableScrollLock
      >
        <MenuItem onClick={() => handleClose("fr")}>
          <Flag
            code="FR"
            style={{ width: 26, height: "auto", marginRight: 10 }}
          />
          {"Fran\u00e7ais"}
        </MenuItem>
        <MenuItem onClick={() => handleClose("en")}>
          <Flag
            code="GB"
            style={{ width: 26, height: "auto", marginRight: 10 }}
          />
          {"English"}
        </MenuItem>
        <MenuItem onClick={() => handleClose("ar")}>
          <Flag
            code="SA"
            style={{ width: 26, height: "auto", marginRight: 10 }}
          />
          {"\u0639\u0631\u0628\u064a"}
        </MenuItem>
        <MenuItem onClick={() => handleClose("es")}>
          <Flag
            code="ES"
            style={{ width: 26, height: "auto", marginRight: 10 }}
          />
          {"Espa\u00f1ol"}
        </MenuItem>
      </Menu>
    </>
  );
};

LanguageSwitcher.propTypes = {
  iconStyle: PropTypes.object,
  iconClassName: PropTypes.string,
  labelColor: PropTypes.string,
};

export default LanguageSwitcher;
